import React from 'react';

function LoadingScreen() {
    return (
        <>
            <section id="loader">
                <div class="container">
                    <div class="loader"></div>
                    <div class="loader"></div>
                    <div class="loader"></div>
                </div>
            </section>
        </>
    )
}

export default LoadingScreen;